import PermissionService from './service';

export * from './reqres';

export default PermissionService;
